export default __webpack_public_path__ + "static/resume-9cb5afa73ae2e86d35e01e5b75324b0d.pdf";